import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { BlueprintGrid, CrossMarker } from "../components/BlueprintGrid";
import { Link } from "react-router-dom";
import { lineMask, EASE } from "../lib/motion";
import { LOCATION_COORDINATE_META } from "../lib/site";

const LINES = ["ONE PROJECT.", "ONE BUILDEASE", "PLAN."];

const PricingHero = () => (
    <section
        data-testid="pricing-hero"
        className="relative flex min-h-[88svh] flex-col overflow-hidden bg-ink"
    >
        <BlueprintGrid />
        <CrossMarker className="absolute right-10 top-28 hidden text-white/25 md:block" />

        <div className="relative z-10 mx-auto flex w-full max-w-[1600px] flex-1 items-center px-6 pb-16 pt-36 md:px-10 lg:px-16">
            <div className="max-w-4xl">
                <motion.p
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: EASE, delay: 0.1 }}
                    className="flex items-center gap-3 font-mono text-[13px] tracking-[0.3em] text-mist"
                >
                    <span className="h-1.5 w-1.5 bg-accent" />
                    PRICING
                </motion.p>

                <h1
                    data-testid="pricing-hero-headline"
                    className="mt-6 font-display text-[clamp(2.4rem,7.5vw,7.5rem)] font-bold leading-[1.1] text-white"
                >
                    {LINES.map((line, i) => (
                        <span
                            key={line}
                            className="-mb-[0.08em] block overflow-hidden pb-[0.08em]"
                        >
                            <motion.span
                                className="block"
                                variants={lineMask}
                                initial="hidden"
                                animate="show"
                                custom={i}
                            >
                                {i === LINES.length - 1 ? (
                                    <>
                                        PLAN
                                        <span className="text-accent">.</span>
                                    </>
                                ) : (
                                    line
                                )}
                            </motion.span>
                        </span>
                    ))}
                </h1>

                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.9, ease: EASE, delay: 0.7 }}
                    className="mt-8 max-w-lg text-[16px] leading-relaxed text-mist md:text-base"
                >
                    Your BuildEase plan is linked to your construction project
                    — not your account. Pay once per project. Keep lifetime
                    access to it.
                </motion.p>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.9, ease: EASE, delay: 0.85 }}
                    className="mt-10"
                >
                    <Link
                        to="/join-the-pilot"
                        data-testid="pricing-hero-join-pilot"
                        className="inline-flex items-center gap-2 bg-accent px-7 py-4 text-sm font-semibold tracking-wide text-white transition-colors duration-300 hover:bg-[#ff7026]"
                    >
                        Join the Pilot
                        <ArrowUpRight className="h-4 w-4" />
                    </Link>
                </motion.div>
            </div>
        </div>

        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1.1 }}
            className="relative z-10 border-t border-white/10"
            data-testid="pricing-metadata-bar"
        >
            <div className="mx-auto flex max-w-[1600px] items-center justify-between gap-6 px-6 py-4 font-mono text-[13px] tracking-[0.24em] text-mist/80 md:px-10 lg:px-16">
                <span className="hidden sm:block">BUILD INTELLIGENCE</span>
                <span data-testid="pricing-stage-counter">PRICING</span>
                <span>SOUTH AFRICA</span>
                <span className="hidden md:block">{LOCATION_COORDINATE_META}</span>
            </div>
        </motion.div>
    </section>
);

export default PricingHero;
